
import Icon from 'vux/src/components/icon/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'

export default {
directives: {
TransferDom
},
components: {Popup,Icon },
props: {
keywordclick:{
type: Function,
default: undefined,
required: false
},
del:{
type: Function,
default: undefined,
required: false
},
close:{
type: Function,
default: undefined,
required: false
},
ispoint:{
type: Boolean,
default: false
},
show:{
type: Boolean,
default: false
}
},
watch:{
},
created(){
if(!this.ispoint){
this.keywordTxt = [1,2,3,4,5,6,7,8,9,0]
}else {
this.keywordTxt = [1,2,3,4,5,6,7,8,9,'.',0]
}

},
data () {
return {
keywordTxt:[],
}
},
methods:{
numberKeywordClick(val){
this.$emit('keywordclick',val);
},
numberKeyworddel(){
this.$emit('del');
},
closePopup(){
this.$emit('close');

},
},
mounted() {
document.getElementsByClassName('numberKeyword')[0].style.height = window.innerHeight + 'px';
}
}



// WEBPACK FOOTER //
// ./src/components/numberKeyword.vue